import { useContext } from "react";

import TableContext from "context/table/tableContext";
import { TABLE_NAMES_WITH_FILTERS } from "shared/types/enums";

import {
    CompanyFilters,
    DeviceDetailConfigChanges,
    DeviceDetailTaskFilters,
    DeviceFilters,
    DeviceGroupDetailFilters,
    DeviceGroupFilters,
    DeviceModelFilters,
    DeviceModelTaskCompatibilityFilters,
    FileFilters,
    PermissionFilters,
    RoleFilters,
    TaskGroupDetailTaskFilters,
    TaskGroupFilters,
    UserFilters
} from "./PageFilters";

const Filters = () => {
    const { tableNameForFilters } = useContext(TableContext);

    const renderContent = () => {
        switch (tableNameForFilters) {
            case TABLE_NAMES_WITH_FILTERS.Devices:
                return <DeviceFilters />;
            case TABLE_NAMES_WITH_FILTERS.DeviceDetailConfigChanges:
                return <DeviceDetailConfigChanges />;
            case TABLE_NAMES_WITH_FILTERS.DeviceDetailTasks:
                return <DeviceDetailTaskFilters />;
            case TABLE_NAMES_WITH_FILTERS.TaskGroups:
                return <TaskGroupFilters />;
            case TABLE_NAMES_WITH_FILTERS.TaskGroupDetailTasks:
                return <TaskGroupDetailTaskFilters />;
            case TABLE_NAMES_WITH_FILTERS.DeviceGroups:
                return <DeviceGroupFilters />;
            case TABLE_NAMES_WITH_FILTERS.DeviceGroupDetailTasks:
                return <DeviceGroupDetailFilters />;
            case TABLE_NAMES_WITH_FILTERS.Files:
                return <FileFilters />;
            case TABLE_NAMES_WITH_FILTERS.Companies:
                return <CompanyFilters />;
            case TABLE_NAMES_WITH_FILTERS.Users:
                return <UserFilters />;
            case TABLE_NAMES_WITH_FILTERS.Roles:
                return <RoleFilters />;
            case TABLE_NAMES_WITH_FILTERS.DeviceModels:
                return <DeviceModelFilters />;
            case TABLE_NAMES_WITH_FILTERS.DeviceModelTaskCompatibilities:
                return <DeviceModelTaskCompatibilityFilters />;
            case TABLE_NAMES_WITH_FILTERS.Permissions:
                return <PermissionFilters />;
            default:
                return <div />;
        }
    };

    return renderContent();
};

export default Filters;
